<template>
  <div id="notFound" class="text--center home-container">
    <h1 class="black__base__color">{{ $t("notFound.title") }}</h1>
    <h1 class="black__base__color">{{ $t("notFound.msg") }}</h1>
    <el-button class="secondary__color__button" @click.prevent="goHome">{{
      $t("notFound.goHomeBtn")
    }}</el-button>
  </div>
</template>
<script>
import { Vue } from "vue-class-component";
export default class NotFound extends Vue {
  goHome() {
    this.$router.push({ name: "Home" });
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
